import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/modules/auth'
import {Stage, Edition, Widget, CustomForm, Color, Menu} from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        currentFormLanguage: 'pl',
        stages: [],
        editions: [],
        colors: [],
        availableWidgets: {},
        availableLinkOptions: {
            "event": [],
            "page": [],
            "news": [],
            "stand": []
        },
        widgetTypes: {},
        idBasedWidgetTypes: {},
        fieldTypes: {},
    },
    mutations: {
        setCurrentFormLanguage (state, language) {
            state.currentFormLanguage = language
        },
        setStages (state, payload) {
            state.stages = payload
        },
        setEditions (state, payload) {
            state.editions = payload
        },
        setColors (state, payload) {
            state.colors = payload
        },
        setAvailableWidgets (state, payload) {
            state.availableWidgets = payload
        },
        setAvailableLinkOptions (state, payload) {
            state.availableLinkOptions = payload
        },
        setIdBasedWidgetTypes (state, payload) {
            state.idBasedWidgetTypes = payload
        },
        setWidgetTypes (state, payload) {
            state.widgetTypes = payload
        },
        setAvailableFields (state, payload) {
            state.availableFields = payload
        },
        setFieldTypes (state, payload) {
            state.fieldTypes = payload
        },
    },
    actions: {
        fetchStages ({commit}) {
            return Stage.fetch().then(response => {
                commit('setStages', response.data)
            }).catch(error => {
                console.error(error)
            })
        },
        fetchEditions ({commit}) {
            return Edition.fetch().then(response => {
                commit('setEditions', response.data)
            }).catch(error => {
                console.error(error)
            })
        },
        fetchColors ({commit}) {
            return Color.fetch().then(response => {
                commit('setColors', response.data)
            }).catch(error => {
                console.error(error)
            })
        },
        fetchAvailableWidgets ({commit}) {
            return Widget.available().then(response => {
                commit('setAvailableWidgets', response.data)
            }).catch(error => {
                console.error(error)
            })
        },
        fetchAvailableLinkOptions ({commit}) {
            Menu.availableLinkOptions().then(response => {
                commit('setAvailableLinkOptions', response.data)
            }).catch(error => {
                console.error(error)
            })
        },
        fetchWidgetTypes ({commit}) {
            return Widget.types().then(response => {
                commit('setWidgetTypes', response.data)
                const idBasedWidgetTypes = {}
                Object.keys(response.data).map(key => {
                    idBasedWidgetTypes[response.data[key].polymorphic_ctype] = {
                        'resourcetype': key,
                        'label': response.data[key].label,
                        'global': response.data[key].global_scope,
                        'polymorphic_ctype': response.data[key].polymorphic_ctype,
                    }
                })
                commit('setIdBasedWidgetTypes', idBasedWidgetTypes)
            })
        },
        fetchFieldTypes ({commit}) {
            return CustomForm.fieldTypes().then(response => {
                commit('setFieldTypes', response.data)
            })
        },
    },
    getters: {},
    setters: {},
    modules: {
        auth
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js